/**
 * Where a card beside the rail sits, from the layer's top: where it wants to
 * be, held between the page card's top (minTop, its gap from the header) and
 * the lowest top that keeps it above the page card's bottom (bottomLimit).
 */
export function placeRailCard(desiredTop: number, bottomLimit: number, minTop = 0): number {
  return Math.min(Math.max(desiredTop, minTop), bottomLimit)
}

/** The gap between the cards, and from the window's right and bottom edges. */
export function readPageCardGap(element: Element): number {
  return parseFloat(getComputedStyle(element).getPropertyValue('--page-card-gap')) || 0
}

/** The cards' gap from the header (-top) or from the rail (-left). */
export function readPageCardGapFrom(element: Element, side: 'top' | 'left'): number {
  return parseFloat(getComputedStyle(element).getPropertyValue(`--page-card-gap-${side}`)) || 0
}
